import * as types from "../actions/dashboardTypes";


  const initialState = {
    data: [],
    loading: false,
    error: null,
  };

  const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_DASHBOARD_REQUEST:
            ////console.log(action.payload)
            return { 
                ...state,
                loading: true,
                error: null 
            };
        //for fetching dashboard
        case types.FETCH_DASHBOARD_SUCCESS:
            ////console.log(action.payload)
            return { 
                ...state, 
                loading: false,
                data: action.payload 
            };

            
      case types.FETCH_DASHBOARD_FAILURE:
         return {
            ...state,
            loading: false,
            error: action.payload,
          };
        default:
          return state;
      }
    };
  
    export default dashboardReducer;